// constants/colors.ts
export const APP_COLORS = {
  ERROR: '#d32f2f',
  WARNING: '#ffa503',
  SUCCESS: '#4caf50',
  DISABLED: '#808080',
  INFO: '#1976d2',
  NEUTRAL: '#9e9e9e',
} as const;
